import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import throttle from 'lodash/throttle'
import { loadState, saveState } from './localStorage'
import { migratePersistedState } from './migratePersistedState'
import { analytics } from './analytics'
import { appReducer } from '@open-tender/cloud'

const rootReducer = appReducer

const persistedState = migratePersistedState(loadState())

const customizedMiddleware = getDefaultMiddleware({
  immutableCheck: false,
  serializableCheck: false,
})

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: customizedMiddleware.concat(analytics),
})

store.subscribe(
  throttle(() => {
    saveState(store.getState())
  }, 3000)
)

export default store
